$(document).ready(function () {    

    var store_name = $("#store_name").val();
    var login_check = $("#login_check").val();
    var customer_email = '';

    if (login_check) {
        customer_email = $("#customer_email").val();
    }

    var data = JSON.stringify({
        "store_name": store_name,
        "login_check": login_check,
        "customer_email": customer_email
    });

    var xhr = new XMLHttpRequest();

    xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
            var jsonResponse = JSON.parse(this.responseText);
            var status = jsonResponse.status;
          
            if (status) {
                var useCookies = jsonResponse.frequency == 1;

                // Check page visibility condition
                var currentUrl = window.location.pathname;
                var blockedPages = ["/pages/kundeklubb", "/a/loyalty"];
                
                if (jsonResponse.page_visibility == 2 && currentUrl != Shopify.routes.root) {
                  console.log("Popup hidden due to its not the Home page.");
                  return;
                }
                
                if (jsonResponse.page_visibility == 0 && blockedPages.some(page => currentUrl.startsWith(page))) {
                    console.log("Popup hidden due to page visibility settings.");
                    return;
                }

                // Check member visibility condition
                var memberVisibility = jsonResponse.member_visibility;
                var memberCheck = jsonResponse.member_check;
                if (memberVisibility == 0 && login_check == 1 && memberCheck) {
                    console.log("Popup hidden due to member visibility settings");
                    return;
                }
                if (memberVisibility == 1 && (login_check == 0 || !memberCheck)) {
                    console.log("Popup will be shown since user is not logged in or not a member");
                }

                var image = jsonResponse.image
                    ? "https://dialog.modish.no/" + jsonResponse.image
                    : "https://cdn.shopify.com/s/files/1/0079/5636/5423/files/PHOTO-2024-02-05-13-57-21.jpg?v=1710677624";

                // Popup HTML
                var html = '<div id="popup" class="popup">';
                html += ' <div class="popup-content" id="popup-content-wrapper" style="background: ' + jsonResponse.background_color + ';">';
                html += '<div class="popup-image-wrapper"><img id="popup-image" width="100%" height="100%" src="' + image + '"></div>';
                html += ' <div class="popup-content-text-wrapper">';
                html += ' <span class="popup-close" onclick="closePopup()">&times;</span>';
                html += '<div class="newsletter-popup__content custom-1">';
                html += '<h3 id="pop_header_text" style="color: ' + jsonResponse.header_text_color + '; font-size: ' + jsonResponse.header_text_size + 'px;">' + jsonResponse.header_text + '</h3>';
                html += ' <div id="pop_description">' + jsonResponse.description + '</div>';
                html += '<form>';
                html += '<div class="popup-input-container">';
                html += '<input class="input-field" type="hidden" name="url" id="popup-input-url" value="' + jsonResponse.button_url + '">';
                html += '<input class="input-field" type="email" placeholder="' + jsonResponse.email_placeholder + '" name="email" id="popup-input-email" style=" padding: 8px 18px; background-color: ' + jsonResponse.email_background_color + '; border-color: ' + jsonResponse.email_border_color + '; margin: 0;">';
                
                if (jsonResponse.button_text) {
                    html += '<button type="button" id="popupButton" target="_blank" class="button-link-text" style="font-size: 12px; padding: 10px 25px; width: 50%; background-color: ' + jsonResponse.button_background_color + '; color: ' + jsonResponse.button_text_color + ';">' + jsonResponse.button_text + '</button>';
                } else {
                    html += '<button type="button" id="popupButton" target="_blank" class="button-link-text" style="font-size: 12px; padding: 10px 25px; width: 50%; background-color: ' + jsonResponse.button_background_color + '; color: ' + jsonResponse.button_text_color + ';"><img style=" width: 23px; margin: auto; " src="https://cdn.shopify.com/s/files/1/0567/1380/5987/files/up-arrow-svgrepo-com.svg?v=1708366385"  alt=""  width="20" height="20"></button>';
                }

                html += '<input type="hidden" name="oic" value="shopify_popup">';
                html += ' </div>';
                html += '</form>';
                html += '</div>';
                html += '</div>';
                html += '</div>';
                html += '</div>';

                document.getElementById('custom_popup').innerHTML = html;

                // Show Popup Logic
                    setTimeout(() => {
                        popup = document.getElementById("popup");

                        function showPopup() {
                            if (!useCookies) {
                                if (document.cookie.indexOf("popupShown=true") === -1) {
                                    popup.style.display = 'flex';
                                    document.cookie = "popupShown=true";
                                }
                            } else {
                                popup.style.display = 'flex';
                            }
                        }

                        closeButton = document.querySelector(".popup-close");

                        function closePopup() {
                            popup.style.display = "none";
                        }

                        showPopup();
                        closeButton.addEventListener("click", closePopup);

                        $('#popupButton').click(function (e) {
                            e.preventDefault();
                            var emailValue = $('input[id="popup-input-email"]').val();
                            var urlValue = $('input[id="popup-input-url"]').val();
                            window.location.href = "/a/loyalty?email=" + encodeURIComponent(emailValue);
                        });
                    }, 1000);
            }
        }
    });

    xhr.open("POST", "https://dialog.modish.no/api/popup-attributes");
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(data);
});
